import React from 'react';
import { Cpu } from 'lucide-react';
import { BlockShell, ci } from './_shared';

// Technische Daten: generisch aus technical.attributes[] (Label/Wert/Einheit).
// Keine fest verdrahteten Feldnamen — die Liste kommt spaeter aus der SAP-Klassifizierung
// oder der product_attributes-Kindtabelle.
// Optionale Gruppierung via char_group-Feld (wird nur angezeigt, wenn Gruppen vorhanden sind).
const BlockTechnical = ({ dto, t, isDarkMode }) => {
  const tech = dto.technical || {};
  const c = ci(isDarkMode);
  const attrs = Array.isArray(tech.attributes) ? tech.attributes : [];

  // Pruefe, ob irgendein Attribut eine char_group hat.
  const hasGroups = attrs.some((a) => a.char_group);

  // Gruppiere Attribute nach char_group; Attribute ohne Gruppe landen unter ''.
  const grouped = hasGroups
    ? attrs.reduce((acc, a) => {
        const grp = a.char_group || '';
        if (!acc[grp]) acc[grp] = [];
        acc[grp].push(a);
        return acc;
      }, {})
    : null;

  const renderAttr = (a, i) => (
    <div key={i} className={`${c.panel} px-3 py-2`}>
      <div className={`text-xs ${c.label}`}>{a.label}</div>
      <div className={`text-sm ${c.value}`}>{a.value}{a.unit ? ` ${a.unit}` : ''}</div>
    </div>
  );

  return (
    <BlockShell title={t('productDetail.technicalData')} icon={Cpu} status={tech.status} isDarkMode={isDarkMode} demoLabel={t('productDetail.demoFromSap')}>
      {attrs.length > 0 ? (
        hasGroups ? (
          <div className="space-y-4">
            {Object.entries(grouped).map(([grp, grpAttrs]) => (
              <div key={grp}>
                {grp && (
                  <div className={`text-xs font-semibold uppercase tracking-wide mb-2 ${isDarkMode ? 'text-white/40' : 'text-slate-400'}`}>
                    {grp}
                  </div>
                )}
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  {grpAttrs.map(renderAttr)}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {attrs.map(renderAttr)}
          </div>
        )
      ) : (
        <p className={`text-sm ${c.sub}`}>{t('productDetail.technicalEmpty')}</p>
      )}
    </BlockShell>
  );
};

export default BlockTechnical;
